const STEPS = [
    {
        number: "01",
        title: "Source",
        body: "We travel to origin — lavender fields in Provence, oud forests in Laos, citrus groves in Calabria — to select only the finest raw materials.",
    },
    {
        number: "02",
        title: "Blend",
        body: "Our perfumer composes each fragrance by hand, balancing top, heart, and base notes to create a scent arc that evolves over the full burn.",
    },
    {
        number: "03",
        title: "Pour",
        body: "Every candle is hand-poured into recyclable glass vessels using 100% vegan soy wax and lead-free cotton wicks. No machines. No shortcuts.",
    },
];

export function ProcessSteps() {
    return (
        <section className="bg-stone-100 py-24">
            <div className="max-w-7xl mx-auto px-6">
                <h2 className="font-serif text-4xl mb-16 text-center font-light">How we work</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {STEPS.map((step) => (
                        <div key={step.number} className="space-y-4">
                            <span className="text-stone-300 font-serif text-5xl font-light">{step.number}</span>
                            <h3 className="font-serif text-2xl">{step.title}</h3>
                            <p className="text-stone-500 font-light leading-relaxed">{step.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
